/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  path {
    fill: #ffc515;
  }
  react {
   fill: #203040;
  }
`

interface GmoneyIcoProps {
  className?: string
}

const GmoneyIco: React.FC<GmoneyIcoProps> = (props: GmoneyIcoProps) => {
  const { className } = props
  return (
    <svg id="icon_gmoney" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" css={Color} className={className}>
      <rect id="사각형_2473" data-name="사각형 2473" width="25" height="26" transform="translate(8 9.051)" fill="#203040"/>
      <path id="패스_7" data-name="패스 7"
            d="M-275.138-83.008a20.286,20.286,0,0,0-6.16-15.02,19.939,19.939,0,0,0-14.84-6.119,19.94,19.94,0,0,0-14.84,6.119,20.286,20.286,0,0,0-6.16,15.02,19.678,19.678,0,0,0,6.16,14.742,19.94,19.94,0,0,0,14.84,6.119,19.94,19.94,0,0,0,14.84-6.119,20.11,20.11,0,0,0,6.16-14.742m-12.88-1.391v9.735c-1.68,1.669-3.92,2.5-7,2.5a9.531,9.531,0,0,1-7.28-2.781,11.309,11.309,0,0,1-3.08-8.344,12.263,12.263,0,0,1,3.08-8.344,9.737,9.737,0,0,1,7.28-3.06,8.327,8.327,0,0,1,6.72,2.781l-2.52,2.781a5.718,5.718,0,0,0-4.2-1.669,4.654,4.654,0,0,0-4.2,2.225,8.52,8.52,0,0,0-1.68,5.285c0,5.007,2.24,7.51,6.16,7.51a8.332,8.332,0,0,0,2.8-.556v-4.45h-3.92V-84.4Z"
            transform="translate(317.138 104.147)" fill="#fc0"/>
    </svg>
  )
}
export default observer(GmoneyIco)
